export const supportService = {
    title: 'Служба поддержки',
    russian_phone_call: 'Для звонков по России — бесплатно',
    foreign_phone_call: 'Для звонков из-за рубежа — платно согласно тарифу оператора',
    call_to_support: 'В службу поддержки вы можете позвонить со следующих номеров',
    add_secretary: 'Добавить помощника',
    change_secretary: 'Изменить помощника',
};
